import { OrganizationAction } from "@common/userOrganizationRoles";
import { useCanPerformOrganizationAction } from "@hooks/permissions/organization/useCanPerformOrganizationAction";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { useOverlays } from "contexts/OverlayContext";

/** Opens the invite-to-firm dialog, or `undefined` when the user can't invite. */
export const useInviteFirmMember = () => {
    const { openOverlay } = useOverlays();
    const activeOrganization = useActiveOrganization();
    const canInviteTeamMember = useCanPerformOrganizationAction(
        OrganizationAction.INVITE_TEAM_MEMBER,
    );

    if (!canInviteTeamMember || !activeOrganization) {
        return undefined;
    }

    return () =>
        openOverlay("organizationAddTeamMember", {
            organization: activeOrganization,
        });
};
